import { Box, Button, Grid, ImageListItem, Modal, Typography } from "@mui/material";
import { useState, useRef } from "react";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
import { NoImage } from "../utility/ImgNIcons";
import { CloudUpload, Delete } from "@mui/icons-material";


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 792,
    height: 600,
    bgcolor: '#1b1b1b',
    borderRadius: 5,
    boxShadow: 24,
    pt: 2,
    px: 2,
    pb: 3,
};


function CameraCapture({ isNominee = false, boxSize = 'fit', smallImageSize = false, setValue, imageUrl, setImageUrl, name }: any) {
    const [cameraStream, setCameraStream] = useState<any>(null);
    const videoRef = useRef<any>(null);
    const canvasRef = useRef<any>(null);
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        stopCamera()

    };

    const startCamera = async () => {
        setOpen(true);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            setCameraStream(stream);
            videoRef.current.srcObject = stream;
            videoRef.current.style.transform = "scaleX(-1)";
        } catch (error) {
            setOpen(false);
            console.error("Error accessing camera:", error);
        }
    };

    const stopCamera = () => {
        if (cameraStream) {
            cameraStream.getTracks().forEach((track: any) => track.stop());
            setCameraStream(null);
            setOpen(false);
        }
    };

    const captureImage = () => {
        if (videoRef.current) {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const context = canvas.getContext("2d");

            context.scale(-1, 1);
            context.translate(-video.videoWidth, 0);

            context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

            context.setTransform(1, 0, 0, 1, 0, 0);

            const imageDataURL = canvas.toDataURL("image/png");
            setImageUrl(imageDataURL)
            setValue(`${name ? name : 'photoUrl'}`, imageDataURL)
            stopCamera()
            setOpen(false);
        }
    };



    return (
        <>
            <Grid sx={{ width: boxSize, display: 'flex', flexDirection: "column", justifyContent: 'space-between' }} item >
                {isNominee && <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} mb={2}>
                        {isNominee ? 'Nominee Image' : 'Profile Image'}
                    </Typography>
                </Box>}
                <ImageListItem sx={{ position: 'relative' }}>
                    {imageUrl ? <Typography sx={{ zIndex: '5', position: 'absolute', top: '0px', right: '0px', backgroundColor: 'red', padding: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px', color: 'white', borderRadius: '8px', fontSize: '12px', cursor: 'pointer', width: '130px', height: '30px', "&:hover": { backgroundColor: 'darkred' } }}
                        onClick={() => {
                            setImageUrl('');
                            setValue(`${name ? name : 'photoUrl'}`, '')
                        }}
                    >
                        <Delete sx={{ width: '18px' }} />
                        Remove image
                    </Typography> : null}
                    <img style={{ objectFit: imageUrl ? "cover" : 'contain', height: smallImageSize ? '170px' : '237px', width: "100%", borderRadius: '8px' }} src={imageUrl ? imageUrl : NoImage} alt="Profile" />
                </ImageListItem>
                <Box sx={{ display: 'flex', gap: '10px', marginTop: '20px' }} >
                    <Button sx={{ backgroundColor: '#3150A1', width: '200px', display: 'flex', gap: '10px', padding: '4px' }} variant="contained" onClick={() => startCamera()}>
                        <CameraAltIcon style={{ width: '16px', height: '16px' }} />
                        <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>{imageUrl ? 'Change Photo' : 'Take Photo'}</Typography>
                    </Button>
                    <Button
                        sx={{ backgroundColor: '#3150A1', width: '200px', padding: '4px', textTransform: 'capitalize' }}
                        component="label"
                        variant="contained"
                        startIcon={<CloudUpload />}
                        href="#file-upload"
                    >
                        Upload a photo
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={(event: any) => {
                                const file = event.target.files[0];
                                if (file) {
                                    const reader = new FileReader();
                                    reader.onload = (e: any) => {
                                        const base64DataUrl = e.target.result;
                                        setImageUrl(base64DataUrl);
                                        setValue(`${name ? name : 'photoUrl'}`, base64DataUrl)
                                    };

                                    reader.readAsDataURL(file);
                                }
                            }}
                        />
                    </Button>
                </Box>
            </Grid >
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <>
                    <Box sx={{ ...style }}>
                        <canvas ref={canvasRef} style={{ display: 'none' }} />
                        <Box sx={{ position: 'relative' }}>
                            <video ref={videoRef} autoPlay muted style={{ width: "100%", height: "570px", borderRadius: '30px' }} />

                            {cameraStream ? (
                                <Box style={{ width: '60px', position: 'absolute', right: '4px', top: '40%' }}>
                                    <CameraAltIcon onClick={() => captureImage()} style={{ width: '46px', height: '46px', marginBottom: '16px', backgroundColor: 'white', padding: '10px', borderRadius: '100%', cursor: 'pointer' }} />
                                    <NoPhotographyIcon onClick={() => stopCamera()} style={{ width: '46px', height: '46px', color: "red", backgroundColor: 'white', padding: '10px', borderRadius: '100%', cursor: 'pointer' }} />
                                </Box>
                            ) : (
                                null
                            )}
                        </Box>

                    </Box>
                </>
            </Modal>
        </>

    )
}

export default CameraCapture;